export default __webpack_public_path__ + "static/media/NH농협.2473e3e4.svg";